var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-indicator"},[_c('div',{staticClass:"indicate",class:{
      'active': _vm.step === 1,
      'pointer': _vm.rightStep,
    },on:{"click":function($event){_vm.rightStep ? _vm.setModalStep('first_step') : null}}}),_c('div',{staticClass:"indicate",class:{
      'active': _vm.step === 2,
      'pointer': _vm.rightStep,
    },on:{"click":function($event){_vm.step === 2 ? _vm.setModalStep('second_step') : null}}})])}
var staticRenderFns = []

export { render, staticRenderFns }